import history from '@/components/contents/searchCommon/history.vue';
<!--
 * @Description  : 
 * @Author       : liulan
 * @Date         : 2021-06-01 09:43:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-09 14:03:06
 * @FilePath: \new_storage\xingmahui_front\src\views\contents\tools\feedRecord\babyBarn.vue
 * Copyright (C) 2021 liulan. All rights reserved.
-->
<template>
  <div class="baby_barn_page">
    <!-- 最大的有内容区 -->
    <span></span>
    <div class="baby_barn_content">
      <div class="header">
        <img
          @click="goBack"
          src="./../../../../assets/images/canEat/arrow_left.png"
          alt=""
        />
      </div>
      <div class="content_top">
        <h3>当前库存</h3>
        <!-- 不为空的库存 -->
        <div class="current_inventory" v-if="isMilkInventor">
          <ul class="inventory_list">
            <li
              class="inventory_item"
              v-for="(item, idx) in milkInventorData"
              :key="idx"
            >
              <dl>
                <dt class="brand_img">
                  <img
                    :src="
                      item.pic
                        ? item.pic
                        : require('./../../../../assets/images/feedRecord/add.png')
                    "
                    alt=""
                  />
                </dt>
                <dd class="brand_explain">
                  <h6 class="name">{{ item.productName }}</h6>
                  <p>{{ item.specs }}g</p>
                  <div class="detailed_description">
                    <span
                      >宝宝口粮不多了&nbsp;&nbsp;剩余<em>{{ item.num }}</em
                      >桶&nbsp;&nbsp;还能再吃<em>{{ item.eatDays }}</em
                      >天</span
                    >
                  </div>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
        <!-- 为空库存 -->
        <div class="inventory_null" v-else>
          <p>粮仓空空如也，快去添加吧～</p>
        </div>
        <!--  -->
        <div class="scanQR">
          <div class="qr_btn">
            <div class="sweep_code btn" @click="sweepCode">
              <span class="sweep_icon"
                ><img
                  src="./../../../../assets/images/feedRecord/sweep_code.png"
                  alt=""
              /></span>
              <font>扫码添加</font>
            </div>
            <div
              v-if="!isHasInventory"
              class="modification_margin btn"
              @click="addMargin"
            >
              <span class="add_icon"
                ><img
                  src="./../../../../assets/images/feedRecord/add_icon.png"
                  alt=""
              /></span>
              <font>手动添加</font>
            </div>
            <div
              v-else
              class="modification_margin btn"
              @click="modificationMargin"
            >
              <span class="add_icon"
                ><img
                  src="./../../../../assets/images/feedRecord/add_icon.png"
                  alt=""
              /></span>
              <font>修改余量</font>
            </div>
          </div>
          <p class="comments_qr">注：扫码添加只适用于飞鹤奶粉</p>
        </div>
        <!--  -->
        <div class="record">
          <h4>添加记录</h4>
          <div class="screen">
            <!-- 多选选择框 -->
            <div class="scroll">
              <div
                v-for="item in addRecordTabs"
                :key="item.id"
                :class="['sizer', item && item.checked ? 'active' : '']"
                @click="handleTab(item)"
              >
                <div class="rule">
                  {{ item && item.rule }}{{ item && item.weight }}g
                </div>
                <div class="sum">{{ item && item.num }}桶</div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="record_list" v-if="hasList">
            <van-list
              class="reserve-list"
              v-model="isUpLoading"
              :finished="upFinished"
              :immediate-check="true"
              finished-text="——已经到底了哦——"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="onLoadList"
              :offset="40"
            >
              <div
                class="record_list_item"
                v-for="(item, idx) in list"
                :key="idx"
                :title="item.productName"
              >
                <span class="record_pro">
                  <font class="weight">{{ item.productName }}</font>
                  <font class="amount">{{ item.sum }}桶</font>
                </span>
                <span class="record_time">{{
                  timeChange(item.createTime)
                }}</span>
              </div>
            </van-list>
          </div>
          <!-- 无列表数据 -->
          <div class="record_null" v-else>
            <p>今天还没有喂养记录哦～</p>
          </div>
        </div>
        <!-- 轮播 -->
        <div class="slider">
          <van-swipe :autoplay="5000" @change="onChangeSwiper">
            <van-swipe-item
              v-for="(image, index) in sliderImgs"
              :key="index"
              @click="onClickSwiper(index)"
            >
              <img class="slider_img" :src="image.picUrl" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import feedRecordsApi from "@/utils/axiosApi/feedRecordsApi";
import wx from "weixin-js-sdk";

export default {
  name: "BabyBarn",
  data() {
    return {
      nullTip: "空空如也~",
      size: 20, // 每页条数
      page: 1, // 页码
      list: [], // 请求数据
      hasList: true,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 40, // 滚动条与底部距离小于 offset 时触发load事件
      error: false,
      checkedArr: ["S01", "S02", "S03"],
      milkPar: {
        crmId: '',
        monthAge: null,
        minNum: null,
        maxNum: null,
      },
      milkInventorData: [],
      isMilkInventor: true,
      isHasInventory: false, // 是否有库存记录
      curIdx: "",
      addRecordTabs: [
        {
          id: "S01",
          rule: "1段",
          weight: 0,
          num: 0,
          checked: false,
        },
        {
          id: "S02",
          rule: "2段",
          weight: 0,
          num: 0,
          checked: false,
        },
        {
          id: "S03",
          rule: "3段",
          weight: 0,
          num: 0,
          checked: false,
        },
      ], // 添加记录tab
      sliderImgs: [],
      current: 0,
      localuserInfo: {}
    };
  },
  mounted() {
    this.localuserInfo = JSON.parse(localStorage.getItem('userInfo'))
    ? JSON.parse(localStorage.getItem('userInfo')) : {}
    this.milkPar.crmId = 'CRM000000000043658926'
    this.milkPar.monthAge = 6
    this.milkPar.minNum = 400
    this.milkPar.maxNum = 600
    this.initMilkInventory(); // 初始库存页面
    this.getBanner(); // 轮播图
    // if(this.localuserInfo !== '{}') {
    //   this.milkPar.crmId = this.localuserInfo.crm_id
    // }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    initMilkInventory() {
      // 获取奶粉库存
      feedRecordsApi.getMilkInventory({ ...this.milkPar }, (res) => {
        // console.log(res, 'res')
        this.milkInventorData = res.data;
        this.$store.commit(
          "SAVE_INVENTORY",
          JSON.parse(JSON.stringify(res.data))
        );

        if (this.milkInventorData.length > 0) {
          this.isMilkInventor = true; // 有库存显示库存列表
        } else {
          this.isMilkInventor = false; // 无库存显示空模块
        }

        this.isHasInventory = this.milkInventorData.some((item) => {
          // 判断有库存true就是修改余量 无库存false就是手动添加
          // console.log(item, 'itemd')
          return item.num > 0;
        });
      });
    },
    timeChange(times) {
      // 格式化时间 年.月.日
      if (!times) {
        return;
      } else {
        let data = new Date(times);
        let dateMonth = data.getMonth() + 1;
        let dayStr = data.getDate();
        let _nowDate = data.getFullYear() + "." + dateMonth + "." + dayStr;
        return _nowDate;
      }
    },
    handleTab(item) {
      // 点击TAB
      this.curIdx = item.id;
      this.addRecordTabs = this.addRecordTabs.map((v, i) => {
        if (this.curIdx == v.id) {
          v.checked = !v.checked;
        }
        return v;
      });

      let arr = this.addRecordTabs.filter((ele, index) => {
        return ele.checked == true;
      });
      let newArr = [];
      for (let j = 0; j < arr.length; j++) {
        if (arr[j].checked) {
          if (newArr.indexOf(arr[j].id) < 0) {
            newArr.push(arr[j].id);
          }
        } else {
          if (newArr.indexOf(arr[j].id) > -1) {
            newArr = newArr.splice(newArr.indexOf(arr[j].id), 1);
          }
        }
      }
      // console.log(newArr, 220);

      this.checkedArr = newArr;
      console.log(
        JSON.parse(JSON.stringify(this.checkedArr)),
        "this.checkedArr",
        this.checkedArr
      );
      if (newArr.length == 0) {
        this.checkedArr = ["S01", "S02", "S03"];
      }
      this.page = 1;
      this.initAddRecord();
    },
    // 获取资源表单列表
    initAddRecord() {
      let _this = this;
      feedRecordsApi.postAddRecord(
        {},
        {
          data: {
            memberId: "CRM000000000043658926",
            productDanList: JSON.parse(JSON.stringify(this.checkedArr)),
          },
          page: this.page,
          size: this.size,
        },
        (res) => {
          // this.list = res.data.memberProductExtendList
          // console.log(res.data.memberProductExtendList, "res187", this.list);
          if (res.code == "200") {
            this.list = JSON.parse(
              JSON.stringify(res.data.memberProductExtendList)
            );
            if (this.list.length > 0) {
              this.hasList = true;
            } else {
              this.hasList = false;
            }

            // 赋值给tabs数据
            this.addRecordTabs = this.addRecordTabs.map((ele, idx) => {
              // console.log(ele, "ele");
              if (ele.id == "S01") {
                ele.num = res.data.S01countNum;
                ele.weight = res.data.S01countWeight;
              } else if (ele.id == "S02") {
                ele.num = res.data.S02countNum;
                ele.weight = res.data.S02countWeight;
              } else if (ele.id == "S03") {
                ele.num = res.data.S03countNum;
                ele.weight = res.data.S03countWeight;
              }
              return ele;
            });
          }

          if (
            res.data.memberProductExtendList == null ||
            res.data.memberProductExtendList.length == 0
          ) {
            // 加载结束
            _this.upFinished = true;
            return;
          }
          if (res.data.memberProductExtendList.length < _this.size) {
            // 最后一页不足size条的情况
            _this.upFinished = true;
            return;
          }
          // 处理数据
          alert(this.page);
          if (_this.page == 1) {
            _this.list = res.data.memberProductExtendList;
            // console.log(_this.list, "111");
          } else {
            _this.list = _this.list.concat(res.data.memberProductExtendList);
            // console.log(_this.list, "2222");
          }
          _this.isDownLoading = false;
          _this.isUpLoading = false;
        }
      );
      // }).catch(error => {
      // this.error = true
      //   this.$message({
      //     showClose: true,
      //     message: '获取资源列表异常{' + error + '}',
      //     type: 'error'
      //   })
      // }).finally(() => {
      //   _self.isDownLoading = false
      //   _self.isUpLoading = false
      // })
    },
    // onDownRefresh() {
    //   this.page = 1
    //   this.upFinished = false
    //   this.initAddRecord() // 加载数据
    // },
    // 上拉加载请求方法
    onLoadList() {
      this.initAddRecord();
      this.page++;
    },
    sweepCode() {
      var that = this;
      // 扫码添加
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
          console.log(res);
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          //  const res = 'http://crmuat.feihe.com/wechat-service/v1/web/t/07134534347301193346?channel=zzsm'
          if (result.search("feihe.com/wechat-service") != -1) {
            that.$router.push({
              path: "/inventoryRecords",
              query: {
                state: 1,
              },
            });
          } else {
            that.$router.push({ path: "/sweepCodeFail" });
          }
        },
      });
    },
    addMargin() {
      // 手动添加
      this.$router.push({
        path: "/manuallyAdd",
        query: {
          state: 0,
        },
      });
    },
    modificationMargin() {
      // 修改余量
      this.$router.push({
        path: "/inventoryRecords",
        query: {
          state: 0,
        },
      });
    },
    // onLoad() {
    // singleChecked(event) {
    //   t = 1
    //   // 默认初始点 都为 1
    //   console.log(event); // 点击多选框请求列表数据
    //   console.log(JSON.parse(JSON.stringify(event)),'发送请求====================================');
    //   this.initAddRecord() // 更新列表数据
    // },
    getBanner() {
      // 获取轮播图
      feedRecordsApi.getFeedBanner({ moduleType: 4 }, (res) => {
        // console.log(res, '轮播图')
        if (res.code == "200") {
          this.sliderImgs = res.data;
        }
      });
    },
    onChangeSwiper(index) {
      this.current = index;
    },
    onClickSwiper(index) {
      this.current = index;
      if (!item.jumpUrl) {
        return;
      } else {
        window.location.href = item.jumpUrl;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.baby_barn_page {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  .baby_barn_content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    ::-webkit-scrollbar {
      display: none;
    }
    .header {
      width: 100%;
      height: 47px;
      padding: 15px 13px 12px;
      box-sizing: border-box;
      background: #ffffff;
      > img {
        width: 10px;
        height: 20px;
      }
    }
    .content_top {
      width: 100%;
      flex: 1;
      overflow-y: scroll;
      background: #f2f2f2;
    }
    .slider {
      // 轮播图
      width: 100%;
      height: 198px;
      padding: 0 12px;
      box-sizing: border-box;
      position: relative;
      background: #ffffff;
      padding-top: 12px;
      box-sizing: border-box;
      .van-swipe__indicators {
        width: 100%;
        height: 20px;
        line-height: 20px;
      }
      /deep/ .van-swipe {
        width: 100%;
        height: 130px;
        display: flex;
        flex-direction: column;
        background: #ffffff;
      }
      .van-swipe /deep/ .van-swipe-item {
        height: 110px;
      }
      .van-swipe /deep/ .van-swipe-item .slider_img {
        height: 110px;
      }
      .van-swipe /deep/ .van-swipe__indicators {
        height: 20px;
        position: absolute;
        bottom: 0;
        display: flex;
        padding-top: 8px;
        box-sizing: border-box;
      }
      .van-swipe /deep/ .van-swipe__indicators .van-swipe__indicator {
        width: 4px;
        height: 4px;
        background: #999999;
        // margin-left: 4px;
      }
      .van-swipe /deep/ .van-swipe__indicators .van-swipe__indicator--active {
        width: 12px;
        height: 4px;
        background: #f1cd8f;
        border-radius: 2px;
      }
      .slider_img {
        display: inline-block;
        width: 100%;
        height: 110px;
      }
    }
  }
  h3 {
    width: 100%;
    padding: 0 17px;
    box-sizing: border-box;
    height: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 18px;
    background: #ffffff;
  }
  .current_inventory {
    width: 100%;
    padding: 0 13px;
    box-sizing: border-box;
    background: #ffffff;
    .inventory_list {
      width: 100%;
      background: #ffffff;
      .inventory_item {
        width: 100%;
        background: #ffffff;
        padding: 8px 4px;
        box-sizing: border-box;
        dl {
          width: 100%;
          flex: 1;
          display: flex;
          box-shadow: 0px 3px 10px 0px rgba(200, 201, 204, 0.5);
          border-radius: 8px;
          padding: 15px 4px 14px;
          box-sizing: border-box;
          .brand_img {
            width: 92px;
            height: 92px;
            > img {
              width: 92px;
              height: 92px;
            }
          }
          .brand_explain {
            width: 100%;
            flex: 1;
            padding-left: 12px;
            box-sizing: border-box;
            .name {
              font-size: 14px;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
            }
            p {
              height: 18px;
              font-size: 12px;
              color: #999999;
              line-height: 18px;
              margin: 12px 0;
            }
            .detailed_description {
              span {
                height: 18px;
                font-size: 12px;
                color: #999999;
                line-height: 18px;
                > em {
                  font-style: normal;
                  color: #fb9580;
                }
              }
            }
          }
        }
      }
    }
  }
  .inventory_null {
    width: 100%;
    height: 167px;
    padding: 0 109px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #ffffff;
    p {
      height: 12px;
      font-size: 12px;
      color: #999999;
      line-height: 12px;
    }
  }
  .record_null {
    width: 100%;
    height: 185px;
    padding: 0 109px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #ffffff;
    p {
      height: 12px;
      font-size: 12px;
      color: #999999;
      line-height: 12px;
    }
  }
  // 扫码
  .scanQR {
    width: 100%;
    background: #ffffff;
    padding: 14px 0px 14px 0;
    box-sizing: border-box;
    .qr_btn {
      width: 100%;
      display: flex;
      justify-content: center;
      .btn {
        width: 132px;
        height: 36px;
        background: #d7a85c
          linear-gradient(
            132deg,
            rgba(255, 255, 255, 0.5) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        border-radius: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.sweep_code {
          margin-right: 31px;
        }
        .sweep_icon {
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          margin-right: 4px;
          > img {
            width: 16px;
            height: 16px;
          }
        }
        .add_icon {
          width: 13px;
          height: 16px;
          display: flex;
          align-items: center;
          margin-right: 4px;
          > img {
            width: 13px;
            height: 16px;
          }
        }
        > font {
          height: 36px;
          font-size: 18px;
          color: #ffffff;
          line-height: 36px;
        }
      }
    }
    .comments_qr {
      width: 100%;
      height: 18px;
      font-size: 12px;
      color: #999999;
      line-height: 18px;
      margin-top: 18px;
      text-align: center;
    }
  }
  //
  .record {
    width: 100%;
    background: #ffffff;
    margin-top: 10px;
    ::-webkit-scrollbar {
      display: none;
    }
    h4 {
      width: 100%;
      height: 54px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 18px;
      padding: 18px 0 18px 25px;
      box-sizing: border-box;
    }
    .screen {
      width: 100%;
      padding-left: 24px;
      box-sizing: border-box;
      overflow-x: scroll;
      .scroll {
        width: 100%;
        display: flex;
      }
      .sizer {
        width: 33.33%;
        padding: 4px 0;
        box-sizing: border-box;
        text-align: center;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #eeeeee;
        margin-right: 12px;
        &.active {
          border-color: #f1ba3b;
        }
        .rule {
          height: 14px;
          font-size: 10px;
          color: #333333;
          line-height: 14px;
        }
        .num {
          height: 17px;
          font-size: 10px;
          font-weight: 600;
          color: #333333;
          line-height: 14px;
        }
      }
    }
    .reserve-list {
      width: 100%;
    }
    .record_list {
      width: 100%;
      padding: 0 24px;
      box-sizing: border-box;
      // margin-top: 1px;
      // position: relative; // 点击事件失效的原因
      // z-index: -1;
    }
    // .record_list .van-pull-refresh .van-pull-refresh__track
    .reserve-list.van-list .record_list_item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eeeeee;
    }
    // .record_list .van-pull-refresh .van-pull-refresh__track
    .reserve-list.van-list /deep/ .van-list__finished-text {
      height: 90px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // .record_list .van-pull-refresh .van-pull-refresh__track
    .reserve-list.van-list .record_list_item .record_pro {
      flex: 1;
      line-height: 46px;
      display: flex;
      margin: 13px 0;
      .weight {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        flex: 1;
      }
      .amount {
        width: 50px;
        padding-left: 23px;
        box-sizing: border-box;
        line-height: 20px;
        font-size: 12px;
        color: #999999;
      }
    }
    // .record_list .van-pull-refresh .van-pull-refresh__track
    .reserve-list.van-list .record_list_item .record_time {
      width: 58px;
      font-size: 12px;
      color: #999999;
      line-height: 46px;
    }
  }
}
</style>
